export type { ZoneMasterProps } from './zone-master';
export * from './zone-master.routes';

export { default as ZoneMaster, default } from './zone-master';
